import { COMMON_THEME } from './common';
import { AppTheme } from './interfaces';
import { lightTheme } from './light';

export const darkTheme: AppTheme = {
  name: 'Dark',
  ...COMMON_THEME,
  colors: {
    ...COMMON_THEME.colors,
    background: lightTheme.colors.greyscale.c900,
  },
  gradients: {
    ...COMMON_THEME.gradients,
    shimmer: 'linear-gradient(to right, #4a5064 8%, #3c4456 18%, #4a5064 100%)',
  },
};
